module.exports = __webpack_public_path__ + "static/img/enf.50f050da.png";